<template>
  <div
    class="wrapper navigation"
    :class="{'navigation-mobile': isMobile}">
    <div class="nav-pages" v-if="!isMobile">
        <div class="logo-box">
            <div class="img-box_main img"></div>
            <div class="line"></div>
            <div class="img-box_logo img"></div>
        </div>
      <!-- <ct-link href="/">
        <img class="logo" src="@/assets/img/logo.svg" alt="comet academy" width="146">
      </ct-link> -->
      <!-- <ct-nav-item to="/home">
        HOME<span class="underline"></span>
      </ct-nav-item>
      <ct-nav-item to="/courses">
        LIGHT COURSE<span class="underline"></span>
      </ct-nav-item>
      <ct-nav-item to="/quiz">
        QUESTION BANK<span class="underline"></span>
      </ct-nav-item> -->
      <ct-nav-item :to="item.path" v-for="item in navList" :key="item.name">
        {{ $t(item.label)}}<span class="underline"></span>
      </ct-nav-item>
    </div>
    <div class="nav-pages" v-else>
        <div class="fold" @click="openNavModal">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div>
            {{ $t(currentNav.label) || '' }}
        </div>
    </div>
    <div class="nav-user">
      <template v-if="isAuthenticated">
        <ct-dropdown :mode="isMobile ? 'click' : 'hover'">
          <div slot="head">
            <ct-avatar v-if="isMobile" :src="profile.avatar + ''" size="large"></ct-avatar>
            <router-link v-else to="/profile" style="display: inline-block;">
              <ct-avatar :src="profile.avatar + ''" size="large"></ct-avatar>
            </router-link>
          </div>
          <ul slot="body" class="user-dropdown-menu">
            <router-link class="route-item" to="/profile">{{$t('nav.Account')}}</router-link >
            <li class="route-item" @click="handleRout('/admin/')" v-if="isAdminRole">{{$t('nav.Admin')}}</li>
            <li class="route-item" @click="handleRout('/my-homework')">{{$t('nav.MyCourses')}}</li>
            <li class="route-item" @click="handleRout('/logout')">{{$t('nav.Logout')}}</li>
          </ul>
        </ct-dropdown>
        <LanguageSwitcher />
      </template>
      <template v-else>
        <div class="btn-box">
          <ct-button
           class="button-login"
           type="text_secondary"
           @click="redirectPassport('Login')"
          >{{$t('auth.Login')}}</ct-button>
          <ct-button
            v-if="!isMobile"
           class="button-signup"
           type="primary"
           :plain="true"
           @click="redirectPassport('Register')"
           >{{$t('auth.SignUp')}}</ct-button>
          <LanguageSwitcher />
        </div>
      </template>
    </div>

    <div class="nav-modal" v-show="showNavModal">
        <transition name="left-menu">
            <div class="modal-body" v-if="showNavModal">
                <div @click="clickCloseModal" class="close" >
                    <ct-icon name="guanbi" ></ct-icon>
                </div>
                <div class="list">
                    <div
                        class="nav-item"
                        :class="{ 'active-nav': currentNav.name === item.name }"
                        @click="jumpUrl(item)"
                        v-for="item in navList"
                        :key="item.name">
                        {{ $t(item.label) }}
                    </div>
                </div>
            </div>
            </transition>
        <div v-if="showNavModal" class="mask" @click="clickCloseModal"></div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CtNavItem from '@ca/components/CtNavItem'
import CtAvatar from '@ca/components/CtAvatar'
import { vueAppPassportDomin } from '@ca/constants/variables'
import LanguageSwitcher from '@/components/language-switcher/index.vue'

export default {
  name: 'Footer',
  components: {
    LanguageSwitcher,
    'ct-nav-item': CtNavItem,
    'ct-avatar': CtAvatar
  },
  data () {
    return {
      logoPath: require(process.env.VUE_APP_LOGO),
      isMobile: window.innerWidth <= 768,
      showNavModal: false,
      navList: [{
        path: '/live',
        name: 'live',
        label: 'nav.CourseCenter'
      }],
      currentNav: {}
    }
  },
  computed: {
    ...mapGetters(['profile', 'isAuthenticated', 'isAdminRole'])

  },
  watch: {
    $route: {
      handler () {
        const { name, path, meta } = this.$route
        this.currentNav = this.navList.find(item => item.name === name) || {
          path: path,
          name: name,
          label: meta.title || ''
        }
      },
      immediate: true

    }
  },
  methods: {
    ...mapActions(['getProfile']),
    handleRout (route) {
      if (route && route.indexOf('admin') < 0) {
        this.$router.push(route)
      } else {
        window.open('/admin/')
      }
    },
    redirectPassport (path) {
      window.location = `${vueAppPassportDomin}${path}`
    },
    openNavModal () {
      this.showNavModal = true
    },
    clickCloseModal () {
      this.showNavModal = false
    },
    jumpUrl (item) {
      this.showNavModal = false
      this.currentNav = item
      this.$router.push(item.path)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/_varaible.scss';

.logo {
  vertical-align: middle;
  margin-right: .24rem;
}
@media screen and (max-width: 992px) {
  .logo{
    display: none;
  }
}
@media screen and (max-width: 1200px) {
  .logo {
    margin-right: 0;
  }
}
.navigation{
  height: inherit;
  line-height: 76px;
  .nav-item .underline {
    background: transparent;
    margin-top: -4px;
  }
  .router-link-active{
    .ct-link {
      .underline {
        background: $primary;
      }
    }
  }

  .nav-item .ct-link:hover .underline::before {
    background-color: $primary;
  }

  .nav-pages /deep/ {
    float: left;
    height: 100%;
    display: flex;
    align-items: center;
    .logo {
        height: 50px;
        // width: 1.46rem;
    }
    .nav-item {
        .ct-link {
            float: left;
        }
    }
    .logo-box {
        .img {
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            float: left;
            width: 100px;
            height: 100px;
        }
        .img-box_main {
            background-image: url('../../../../assets/img/main-logo.png');
        }
        .img-box_logo {
            background-image: url('../../../../assets/img/logo.png');
        }

        .line {
            float: left;
            width: 1px;
            height: 24px;
            margin: 38px 20px;
            background: #ccc;
            ;
        }
    }
  }
  .nav-user {
    float: right;
    display: flex;
    align-items: center;
    height: 100%;
    .btn-box {
        display: flex;
        align-items: center;
    }
  }
  .drop-menu-user{
    position: absolute;
  }
  .button-login:hover{
    color: $primary;
  }
  // .button-signup{
  //   color: $primary;
  //   border: 1px solid $primary;
  // }
  .user-dropdown-menu{
    .route-item {
        display: block;
        cursor: pointer;
        font-size:14px;
        font-family:SFUIDisplay-Regular;
        font-weight:400;
        color:rgba(26,61,94,1);
        text-align: center;
        line-height: 1;
        padding: 16px 0;
        margin: 0 16px;
        text-decoration: none;
        border-top: 1px solid #EFF4FA;
        position: relative;
        transition: color .2s ease-out;
        &::before{
        position: absolute;
        left: -16px;
        top: 12px;
        content: ' ';
        width:2px;
        height:24px;
        background:transparent;
        transition: background .2s ease-out;
        }
        &:hover{
        color: $primary;
        &::before {
            background: $primary;
        }
        }
        &.router-link-active {
        color:$primary;
        position: relative;
        &::before{
            background:$primary;
        }
        }
    }
  }
}
.navigation-mobile {
    .nav-pages {
        font-size: 14px;
    }
    .button-login {
        padding: 0 10px!important;
        min-width: unset!important;
    }
    .fold {
        width: 20px;
        height: 15px;
        margin-right: 10px;
        span {
            display: block;
            width: 100%;
            height: 3px;
            background: #768b9e;
            margin-bottom: 3px;
        }
    }
    .nav-modal {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 10000;
        .mask {
            width: 100%;
            height: 100%;
            background: #000;
            opacity: 0.3;
            // position: absolute;
            // left: 0;
            // top: 0;
        }
        .modal-body {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            width: 200px;
            background: #fff;
            z-index: 10000;
            padding-top: 50px;
            .close {
                position: absolute;
                right: 10px;
                top: 10px;
                width: 40px;
                height: 40px;
                line-height: 40px;
                font-size: 26px;
                text-align: center;
                z-index: 100000;
            }
            .list {
                width: 100%;
                padding: 0;
                line-height: 36px!important;
                .nav-item {
                    padding: 5px 20px;
                }
                .active-nav {
                    background: #ccc;
                }
            }
        }
    }
    /* 定义进入和离开时的动画 */
    .left-menu-enter {
        animation: left-menu-slide-in 0.3s ease
    }
    .left-menu-leave {
        animation: left-menu-slide-out 0.3s ease forwards
    }
     .left-menu-enter-active {
        animation: left-menu-slide-in 0.3s ease
    }
    .left-menu-leave-active {
        animation: left-menu-slide-out 0.3s ease forwards
    }

}
@keyframes left-menu-slide-in {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(0%);
    }
}
@keyframes left-menu-slide-out {
    0% {
        transform: translateX(0%);
    }
    100% {
        transform: translateX(-100%);
    }
}

</style>
